import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'discountLanding.hero.heading',
		defaultMessage: 'Sleep more and stress less with {percentOff}% off of Calm Premium',
		description: 'Giving user discount price to get subscription',
	},
	headingFirstMonth: {
		id: 'discountLanding.hero.headingFirstMonthPrice',
		defaultMessage: 'Sleep more and stress less with {price} for 1 month of Calm Premium',
		description:
			'Heading for the discounted first month offer. {price} is the formatted first month price, e.g. $1.00',
	},
	headingWithoutDiscount: {
		id: 'discountLanding.hero.headingWithoutDiscount',
		defaultMessage: 'Sleep more and stress less with Calm Premium',
		description: 'Generic upsell heading',
	},
	cta: {
		id: 'discountLanding.hero.cta',
		defaultMessage: 'Claim Discount',
		description: 'Button which leads user to payment form',
	},
	starRating: {
		id: 'discountLanding.hero.starRating',
		defaultMessage: '5 stars from 1.5M+ users',
		description: 'Telling user how many positive reviews we have',
	},
});
